import React from 'react';
import { graphql } from 'gatsby';
import _ from 'lodash';
import BlogFull from '../components/blog-full';
import SEO from '../components/seo';
import Wrapper from '../containers/wrapper';

export const query = graphql`
  query BlogTemplateQuery($id: String!) {
    blog: sanityBlog(id: { eq: $id }) {
      id
      title
      active
      featured
      slug {
        current
      }
      publishedAt
      description
      sourceName
      sourceUrl
      file {
        _key
        _type
        asset {
          id
          url
        }
      }
      slideDeck {
        title
        slides {
          title
          slide {
            asset {
              _id
            }
          }
        }
      }
      relatedBlogs {
        id
        title
        active
        featured
        slug {
          current
        }
        publishedAt
        description
        embed
        sourceName
        sourceUrl
        file {
          _key
          _type
          asset {
            id
            url
          }
        }
        downloadButton
        caption
        bodyMarkdown
        thumbnail {
          asset {
            _id
          }
        }
        image {
          asset {
            _id
          }
        }
      }
      downloadButton
      bodyMarkdown
      caption
      embed
      thumbnail {
        asset {
          _id
        }
      }
      image {
        asset {
          _id
        }
      }
    }
  }
`;

const BlogTemplate = props => {
  const { data } = props;
  const blog = _.get(data, 'blog');

  if (!blog) {
    throw new Error('Missing site settings');
  }
  
  return (
    <Wrapper>
      <SEO title={blog.title} image={blog.thumbnail} description={blog.description} bodyId="article" defaultMicroData={true} />
      <BlogFull {...blog} />
    </Wrapper>
  );
};

export default BlogTemplate;
